import { render, staticRenderFns } from "./AddressAutosuggest.vue?vue&type=template&id=74f6502f&"
import script from "./AddressAutosuggest.vue?vue&type=script&lang=js&"
export * from "./AddressAutosuggest.vue?vue&type=script&lang=js&"
import style0 from "./AddressAutosuggest.vue?vue&type=style&index=0&id=74f6502f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports